import * as Actions from '../../actions/actions';

const initialState = {
    allMyCoursesList: null
};

const user = (state = initialState, action) => {
    switch (action.type) {
        case Actions.MY_ALL_COURSES:
            return {
                ...state,
                allMyCoursesList: action.data
            };
        default:
            return state;
    }
};
export default user;
